export var EServiceGroup;
(function (EServiceGroup) {
    EServiceGroup["Storage"] = "storage";
    EServiceGroup["Social"] = "social";
    EServiceGroup["Email"] = "email";
    EServiceGroup["Health"] = "health";
})(EServiceGroup || (EServiceGroup = {}));
//# sourceMappingURL=serviceGroup.enum.js.map